/* Grip Tech Tools storefront behaviour, 2026-08-05.
   Two jobs only: attach background video sources lazily, and swap a YouTube
   facade for a real iframe on click. Everything else is CSS. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var slow = navigator.connection && /^(slow-)?2g$/.test(navigator.connection.effectiveType || '');

  /* ---- background video: only load once visible, and never on a metered or
     slow connection, where the poster image is the better experience ---- */
  function attach(video) {
    if (video.dataset.gttAttached) return;
    video.dataset.gttAttached = '1';

    // Read the attributes directly. `data-src-720` does NOT become
    // dataset.src720: the dataset mapping only camel-cases a dash that is
    // followed by a lowercase letter, so a dash before a digit is left alone.
    var lo = video.getAttribute('data-src-720');
    var hi = video.getAttribute('data-src-1080');
    var wide = window.innerWidth >= 900;
    var src = (wide ? hi : lo) || lo || hi;
    if (!src) return;

    video.addEventListener('playing', function () { video.classList.add('is-playing'); }, { once: true });
    video.src = src;
    video.load();
    var p = video.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused, poster stays */ });
  }

  function initVideos() {
    var vids = document.querySelectorAll('video[data-gtt-bg]');
    if (!vids.length) return;
    if (reduce || saveData || slow) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(vids, attach);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        attach(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '200px' });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  /* ---- YouTube facade: no third party frame until the visitor asks ---- */
  function initFilms() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest ? ev.target.closest('[data-gtt-film]') : null;
      if (!btn) return;
      var id = btn.getAttribute('data-gtt-film');
      if (!id) return;
      var title = btn.getAttribute('data-gtt-title') || 'GRABO video';
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
      frame.title = title;
      frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      frame.loading = 'lazy';
      var thumb = btn.querySelector('.gtt-film__thumb');
      if (thumb) thumb.replaceWith(frame); else btn.appendChild(frame);
      btn.removeAttribute('data-gtt-film');
    });
  }

  function boot() { initVideos(); initFilms(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify's theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', initVideos);
})();
